// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__TJNMk","Footer_Copyright":"Footer_Footer_Copyright__QkFX1"};